module.exports = __webpack_public_path__ + "static/img/about-certificate-05.1ac62b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-05.jpg
// module id = vJEV
// module chunks = 1